'use client'

import type React from 'react'
import dynamic from 'next/dynamic'
import { Suspense } from 'react'
import type { RoleKey } from './schemas'
import { Loader2 } from 'lucide-react'

// Dynamically import the controller; no JS until the dialog opens
const FormClient = dynamic(() => import('./FormClient'), {
  ssr: false, // client-only
})

interface MountFormClientProps {
  endpoint?: string
  initialPosition?: RoleKey
  lockPosition: boolean
}

const MountFormClient: React.FC<MountFormClientProps> = (props) => {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center gap-2 py-6 sm:py-8 text-xs sm:text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>Loading form…</span>
        </div>
      }
    >
      <FormClient {...props} />
    </Suspense>
  )
}

export default MountFormClient
